import { render, staticRenderFns } from "./Registrant.vue?vue&type=template&id=0890e3c6&scoped=true"
import script from "./Registrant.vue?vue&type=script&lang=js"
export * from "./Registrant.vue?vue&type=script&lang=js"
import style0 from "./Registrant.vue?vue&type=style&index=0&id=0890e3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890e3c6",
  null
  
)

export default component.exports